import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthenticationService from "../../../Api/AuthenticationService";
import ClientFooter from "../ClientFooter";


const StudentRegister = () => {
    const AuthObject = new AuthenticationService();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        mobile_number: "",
        password: "",
        confirm_password: "",
        profile_photo_url: ""
    });

    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Validate full name
        if (!formData.full_name.trim()) {
            newErrors.full_name = "Full name is required";
        } else if (formData.full_name.trim().length < 3) {
            newErrors.full_name = "Full name must be at least 3 characters long";
        }

        // Validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        // Validate mobile number
        const phoneRegex = /^\d{10}$/;
        if (!formData.mobile_number.trim()) {
            newErrors.mobile_number = "Mobile number is required";
        } else if (!phoneRegex.test(formData.mobile_number)) {
            newErrors.mobile_number = "Invalid mobile number (10 digits required)";
        }

        // Validate password
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 8) {
            newErrors.password = "Password must be at least 8 characters";
        } else if (!passwordRegex.test(formData.password)) {
            newErrors.password = "Password must contain at least one uppercase letter, one lowercase letter, and one number";
        }

        // Validate confirm password
        if (!formData.confirm_password) {
            newErrors.confirm_password = "Please confirm your password";
        } else if (formData.password !== formData.confirm_password) {
            newErrors.confirm_password = "Passwords do not match";
        }

        // Validate profile photo URL (optional, but if present, should be a valid URL)
        if (formData.profile_photo_url) {
            try {
                new URL(formData.profile_photo_url);
            } catch {
                newErrors.profile_photo_url = "Invalid URL format for profile photo";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setIsLoading(true);
            try {
                const response = await AuthObject.signup({
                    full_name: formData.full_name,
                    email: formData.email,
                    mobile_number: formData.mobile_number,
                    password: formData.password,
                    profile_photo_url: formData.profile_photo_url
                });
                
                const data = await response.data;

                if (response.status === 200 && data.status === "success") {
                    // Navigate to OTP verification with the token
                    alert(data.data.otp);
                    // Store profile_photo_url in cookie
                    document.cookie = `profile_photo_url=${encodeURIComponent(formData.profile_photo_url)}; path=/`;
                    navigate('/StudentOtpVerification', {
                        state: {
                            token: data.data.token,
                            email: formData.email
                        }
                    });
                } else {
                    setErrors(prev => ({
                        ...prev,
                        submit: data.message || "Registration failed. Please try again."
                    }));
                }
            } catch (error) {
                setErrors(prev => ({
                    ...prev,
                    submit: error.response?.data?.message || "Something went wrong. Please try again."
                }));
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {/* Start breadcrumb Area */}
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">Login &amp; Register</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="/" className="text-primary">
                                            <i className="feather-home me-1" />
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">
                                        Login &amp; Register
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Breadcrumb Area */}
            <div className="rbt-elements-area bg-color-white rbt-section-gap">
                <div className="container">
                    <div className="row gy-5 row--30">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="rbt-contact-form contact-form-style-1 max-width-auto">
                                <h3 className="title">Register</h3>
                                {errors.submit && (
                                    <div className="alert alert-danger" role="alert">
                                        {errors.submit}
                                    </div>
                                )}
                                <form className="max-width-auto" onSubmit={handleSubmit}>

                                {formData.profile_photo_url && !errors.profile_photo_url && (
                                            <div style={{ marginTop: 10, marginBottom: 10, textAlign: 'center' }}>
                                                <img
                                                    src={formData.profile_photo_url}
                                                    alt="Profile Preview"
                                                    style={{ maxWidth: 200, maxHeight: 120, borderRadius: '50%', objectFit: 'cover', border: '1px solid #eee' }}
                                                    onError={e => { e.target.style.display = 'none'; }}
                                                />
                                            </div>
                                        )}
                                    <div className="form-group">
                                        <input 
                                            name="full_name" 
                                            type="text" 
                                            value={formData.full_name}
                                            onChange={handleChange}
                                            className={errors.full_name ? 'is-invalid' : ''}
                                        />
                                        <label>Full Name *</label>
                                        <span className="focus-border" />
                                        {errors.full_name && <div className="invalid-feedback">{errors.full_name}</div>}
                                    </div>

                                    <div className="form-group">
                                        <input 
                                            name="email" 
                                            type="email" 
                                            value={formData.email}
                                            onChange={handleChange}
                                            className={errors.email ? 'is-invalid' : ''}
                                        />
                                        <label>Email address *</label>
                                        <span className="focus-border" />
                                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                    </div>

                                    <div className="form-group">
                                        <input 
                                            name="mobile_number" 
                                            type="text" 
                                            value={formData.mobile_number}
                                            onChange={handleChange}
                                            className={errors.mobile_number ? 'is-invalid' : ''}
                                        />
                                        <label>Mobile Number *</label>
                                        <span className="focus-border" />
                                        {errors.mobile_number && <div className="invalid-feedback">{errors.mobile_number}</div>}
                                    </div>

                                    <div className="form-group">
                                        <input 
                                            name="profile_photo_url"
                                            type="url"
                                            value={formData.profile_photo_url}
                                            onChange={handleChange}
                                            className={errors.profile_photo_url ? 'is-invalid' : ''}
                                        />
                                        <label>Profile Photo URL</label>
                                        <span className="focus-border" />
                                        {errors.profile_photo_url && <div className="invalid-feedback">{errors.profile_photo_url}</div>}
                                        
                                    </div>

                                    <div className="form-group">
                                        <input 
                                            name="password" 
                                            type={showPassword ? "text" : "password"}
                                            value={formData.password}
                                            onChange={handleChange}
                                            className={errors.password ? 'is-invalid' : ''}
                                        />
                                        <label>Password *</label>
                                        <span className="focus-border" />
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                    </div>

                                    <div className="form-group">
                                        <input 
                                            name="confirm_password" 
                                            type={showPassword ? "text" : "password"}
                                            value={formData.confirm_password}
                                            onChange={handleChange}
                                            className={errors.confirm_password ? 'is-invalid' : ''}
                                        />
                                        <label>Confirm Password *</label>
                                        <span className="focus-border" />
                                        {errors.confirm_password && <div className="invalid-feedback">{errors.confirm_password}</div>}
                                    </div>

                                    <div className="form-submit-group">
                                        <button
                                            type="submit"
                                            className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
                                            disabled={isLoading}
                                        >
                                            <span className="icon-reverse-wrapper">
                                                {isLoading ? (
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                ) : null}
                                                <span className="btn-text">Register</span>
                                                <span className="btn-icon"><i className="feather-arrow-right" /></span>
                                                <span className="btn-icon"><i className="feather-arrow-right" /></span>
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default StudentRegister;
